(function(){
  'use strict';

  var jwplayer = require("jwplayer");

  var logger = new (require('../helpers/logger.js'))("AudioPlayer").setColor("#6f97f0").setDebug(true);
  var helper = require('../helpers/generic.js');
  var jquery = require('jquery');
  var Overlay = require('../Overlay/main.js');

  module.exports = AudioPlayer;

  var defaultOptions = {
    width: '100%'
  };

  function AudioPlayer(mediaInstance, inline, container, options){
    var self = this;
    this.media = mediaInstance;
    this.inline = inline;
    this.baseContainer = jquery(container);
    this.baseContainer.data("cmy-audioplayer", this);

    this.options = jquery.extend(true, {}, defaultOptions);

    if(!helper.undefOrNull(options)){
      this.options = jquery.extend( true, this.options, options );
    }

    logger.debug("initting jwplayer-audio " + (inline? "inline" : "for overlay"));

    if (inline){
      var playerContainer = jquery("<div></div>");
      container.append(playerContainer);
      self.container = playerContainer;
      self._containerId = "ply-" + new Date().getTime(); //jwPlayer needs individual IDs to be able to display more than one instance at a time
      self.container.attr("id", self._containerId);
      var player = self._initJwPlayer();
      player.on('ready', function(){
        var css = {
          minWidth: '40px',
          display: 'inline-block'
        };

        if (isNaN(self.options.width)){ //should contain unit
          css.width = self.options.width;
        } else {
          css.width = self.options.width + 'px';
        }

        $("#"+self._containerId).css(css);
      });


    } else {
      throw "AudioPlayer: Overlay-Mode is not yet implemented";
      //TODO: Started development but was told that we do not need an overlay-player yet
      jquery(container).append("<span class='cmy-play-audio-in-overlay-button'>Play in Overlay<span>").click(function(){
        self.container = $("<div id='overlay-audio-player'></div>");
        self.overlay = new Overlay(self.container).show();
        self.overlay.addRemovalCallback(function(){
          if (!helper.undefOrNull(self.player)){
            self.player.stop().remove();
          }
        });
        self._initJwPlayer();
      });
    }

  }

  // subclass extends superclass
  AudioPlayer.prototype = {
    _onComplete: function onComplete(){
      if (!this.inline){
        this.player.stop().remove();
        this.overlay.close();
      }
    },
    _play: function _play(){
      var container = this.container;
      var player = this.player;
      player.onReady(function(evt){ //play when initted
        logger.debug("jwplayer playing audio", container);
        player.play();
      });
    },

    _getAsJwSource: function _getAsJwSource(url, type){
      var sources = [];
      if (!helper.undefOrNull(url)){
        var src = { file: url, type: type, 'default': true };
        sources.push(src);
      }
      return sources;
    },

    _getPlayerConfig: function _getPlayerConfig(){
        var ap = this;
        var jwSetup = {
          height: 40, /* height of 40px puts jwPlayer into audio-only mode */
          width: this.options.width,
          ga: {},
          autostart: false,
          events: {
            onComplete: function(){
              ap._onComplete();
            }
          },
          sources: ap._getAsJwSource(ap.media.url(), 'audio/aac')
        };

        logger.debug("Player-Config: ", jwSetup);
        return jwSetup;
    },
    _initJwPlayer: function _initJwPlayer(){
      var container = this.container instanceof jquery ? this.container[0] : this.container;
      var jwSetup = this._getPlayerConfig();
      this.player = jwplayer(container).setup(jwSetup);
      return this.player;
    }
  };

}());



//////////////////
// WEBPACK FOOTER
// ./src/AudioPlayer/audioplayer.js
// module id = 25
// module chunks = 0